<template>
  <div id="goTop">
    <Header :url="url"></Header>
    <div class="index" style="margin-top:1rem">
      <img style="width:100%" src="/static/img/indexBuy/WEEE/banner.jpg" alt />
      <img style="width:100%" src="/static/img/indexBuy/WEEE/1.jpg" alt />
      <img style="width:100%" src="/static/img/indexBuy/WEEE/2.jpg" alt />
      <img style="width:100%" src="/static/img/indexBuy/WEEE/3.jpg" alt />
      <img style="width:100%" src="/static/img/indexBuy/WEEE/4.jpg" alt />
      <img style="width:100%" src="/static/img/indexBuy/WEEE/5.jpg" alt />
      <img style="width:100%" src="/static/img/indexBuy/WEEE/6.jpg" alt />
      <img style="width:100%" src="/static/img/indexBuy/WEEE/7.jpg" alt />
      <img src="/static/img/index/registered-bottom.jpg" alt />
    </div>
    <!-- <a href="#goTop" style="color:#666">
      <p style="padding:10px;background:#ccc;margin:0  ">
        回到顶部
      </p>
    </a> -->
    <div v-show="liderValidation " :style="{height: windowHeight+'px'}" class="maskStyle">
      <slider
        :phoneValue="phoneValue"
        :clickBtnNum="1"
        :slider="slider"
        @sliderSuccess="sliderSuccess"
        ref="slider"
      ></slider>
    </div>
    <div v-if="scrollTop" @click="scrollToTop" class="to-top">
      <img src="/static/img/icon/toTop.png" alt />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import slider from '@/components/slider'
import { debounce, throttle } from '@/util/util'
import { registered, channelNo } from '@/api/land.js'

import Header from '@/components/Header'
export default {
  data () {
    return {
      images: [],
      priceList: [
        {
          country: 0,
          url: '/static/img/indexBuy/yg.png',
          flagUrl: '/static/img/indexBuy/yg-f.png'
        },
        {
          country: 2,
          url: '/static/img/indexBuy/dg.png',
          flagUrl: '/static/img/indexBuy/dg-f.png'
        },
        {
          country: 1,
          url: '/static/img/indexBuy/fg.png',
          flagUrl: '/static/img/indexBuy/fg-f.png'
        },
        {
          country: 4,
          url: '/static/img/indexBuy/xby.png',
          flagUrl: '/static/img/indexBuy/xby-f.png'
        },
        {
          country: 3,
          url: '/static/img/indexBuy/ydl.png',
          flagUrl: '/static/img/indexBuy/ydl-f.png'
        },
        {
          country: 8,
          url: '/static/img/indexBuy/adl.png',
          flagUrl: '/static/img/indexBuy/adl-f.png'
        },
        {
          country: 5,
          url: '/static/img/indexBuy/bl.png',
          flagUrl: '/static/img/indexBuy/bl-f.png'
        },
        {
          country: 7,
          url: '/static/img/indexBuy/hl.png?v=0',
          flagUrl: '/static/img/indexBuy/hl-f.png'
        }
      ],
      priceList1: [
        {
          country: 102,
          url: '/static/img/indexBuy/bz.png',
          flagUrl: '/static/img/indexBuy/bz-f.png'
        },
        {
          country: 103,
          url: '/static/img/indexBuy/dc.png',
          flagUrl: '/static/img/indexBuy/dc-f.png'
        },
        {
          country: 101,
          url: '/static/img/indexBuy/we.png',
          flagUrl: '/static/img/indexBuy/we-f.png'
        },
        {
          country: 104,
          url: '/static/img/indexBuy/oy.png',
          flagUrl: '/static/img/indexBuy/oy-f.png'
        }
      ],
      url: '/aboutWEEE',
      phoneValue: '',
      slider: '#duoge1',
      liderValidation: false,
      scrollTop: false,
      windowHeight: '',
      codeNumber: false,
      codeButton: '发送验证码',
      codeMsgValue: '',
      passWordValue: '',
      surePwd: '',
      time: 60,
      agree: false,
      checkChannelFlag: true,
      aliCode: {},
      toast1: null
    }
  },
  components: { Header, slider },
  created () {
    this.windowHeight = document.documentElement.clientHeight
    // 流量监控
    // let a = document.createElement("script");
    // a.src = "https://hm.baidu.com/hm.js?86ceba52022e26a7fddef7e6e0c626e4";
    // let b = document.getElementsByTagName("script")[0];
    // b.parentNode.insertBefore(a, b);
    document.title = '麦德通'
    document.documentElement.scrollTop = 0

    if (localStorage.getItem('zhuce')) {
      let nowTime = parseInt(
        60 -
          (new Date().getTime() - localStorage.getItem('zhuce').toString()) /
            1000
      ) // 对比时间戳判断倒计时是否结束
      if (nowTime < 0) {
        // 倒计时结束
        this.codeNumber = false
        this.codeButton = '发送验证码'
        localStorage.removeItem('zhuce')
      } else {
        this.codeNumber = true
        this.time = nowTime
        this.codeTime()
      }
    }
    let locationHref = window.location.href
    if (locationHref.indexOf('?') > -1) {
      locationHref = decodeURI(locationHref)
      let param = ''
      if (locationHref.indexOf('&') > -1) {
        let params = locationHref.substring(
          locationHref.indexOf('?') + 1,
          locationHref.indexOf('&')
        )
        param = params.split('=')[1]
      } else {
        param = locationHref
          .substring(locationHref.indexOf('?') + 1)
          .split('=')[1]
      }
      this.aliCode.channelCode = param
    }
    if (this.aliCode.channelCode) {
      this.channel()
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed () {
  },
  methods: {
    scrollToTop () {
      setTimeout(() => {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }, 300)
    },
    handleScroll: throttle(function () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      console.log(scrollTop)
      if (scrollTop > 500) {
        this.scrollTop = true
      } else {
        this.scrollTop = false
      }
    }, 500),
    toBuy (item) {
      let query = {}
      if (item.country == 7) {
        return
      } else {
        query.type = item.country
      }
      this.$router.push({name: 'buyList', query})
    },
    ...mapActions(['GetInfo']),
    showPopup () {
      this.show = true
    },
    /**
     * @description 去登陆
     */
    toLogin () {
      this.$router.push({
        path: '/system/user/loginTest'
      })
    },
    /**
     * @description 检验channelNo
     */
    channel () {
      channelNo({ channelId: this.aliCode.channelCode })
        .then(res => {
          if (res.code == 0) {
            if (!(res.rows.length > 0)) {
              this.$toast({
                message: `该注册码(${this.aliCode.channelCode}获取到的渠道码)有误，请联系您的客服经理`
              })
              this.checkChannelFlag = false
              this.$emit('channelNo', 'false')
            } else {
              this.$emit('channelNo', 'true')
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    /**
     * @description 用户协议
     */
    agreeClick () {
      this.agree = !this.agree
    },
    /**
     *@description 获取验证码的点击事件
     */
    getVerificationCode () {
      // 手机号为空
      if (this.phoneValue === '') {
        this.$toast({ message: '请输入手机号' })
        return
      }
      // 手机号格式不对
      if (!/^[1][0-9]{10}$/.test(this.phoneValue)) {
        this.$toast({ message: '请输入正确的手机号' })
        return
      }
      this.liderValidation = true
      if (this.liderValidation) {
        this.$refs.slider.getScroll()
      }
    },
    /**
     *@description 滑块验证通过
     */
    sliderSuccess (e) {
      if (e !== 'error') {
        this.aliCode = e
        let land5 = new Date().getTime()
        localStorage.setItem('zhuce', land5)
        this.codeTime()
      }
      setTimeout(() => {
        this.liderValidation = false
      }, 500)
    },
    /**
     *@description 获取验证码的button显示
     */
    codeTime () {
      this.codeNumber = true
      let interval = setInterval(() => {
        this.codeButton = `${this.time}s`
        if (this.time-- <= 0) {
          this.codeNumber = false
          this.codeButton = '发送验证码'
          this.time = 60
          window.clearInterval(interval)
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
.to-top {
  position: fixed;
  width: 1rem !important;
  right:5px;
  bottom: 148px;
  height: 1rem !important;
  display: inline-block;
  border-radius: 100%;
  background: white;
  box-shadow: 10px 10px 70px gray;
}
.to-top img {
  width: 100%;
}
.maskStyle {
  background: rgba(0, 0, 0, 0.6);
  z-index: 8;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.maskStyle p {
  text-align: left;
  height: 35px;
  line-height: 35px;
  margin: 8px 0;
  color: red;
  padding-left: 15px;
}
.banner {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.index {
  width: 100%;
}
.index img {
  width: 100%;
}
input {
  border: none;
  outline: none;
}
.content {
  width: 90%;
  margin: 0.5rem auto;
  box-shadow: 0px 0px 40px 0px rgba(102,102,102,0.07);
  border-radius: 10px;
  padding: 0.5rem;
}
.title {
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(11, 167, 255, 1);
  border: 1px solid rgba(11, 167, 255, 0.2);
  border-radius: 10px;
  width: 4.5rem;
  padding: 0.1rem 0;
  margin: 0 auto 0.5rem;
}
.btnClick {
  height: 0.84rem;
  background: rgba(11, 167, 255, 1);
  border-radius: 0.1rem;
  font-size: 0.36rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 0.84rem;
  margin-top: 0.4rem;
}
img {
  display: inline-block;
}
.send-code {
  height: 0.55rem;
  background: rgba(11, 167, 255, 1);
  border-radius: 0.1rem;
  line-height: 0.55rem;
  padding: 0 0.1rem;
  font-size: 0.22rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(254, 255, 255, 1);
}
.ipt-div {
  display: flex;
  height: 0.7rem;
  margin: 0.25rem 0;
}
.ipt-div div {
  border-bottom: 1px solid lightgray;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 0.2rem;
}
.icon-span {
  position: relative;
  display: inline-block;
  width: 0.5rem;
  height: 100%;
}
.icon-span img {
  position: absolute;
  width: 100%;
  bottom: 0.1rem;
  left: 0;
}
.agree {
  position: relative;
  display: flex;
  font-size: 0.2rem;
  padding-left: 0.3rem;
}
.radius1 {
  /* position: absolute;
  bottom: 0.08rem; */
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 100%;
  border: 1px solid rgba(11, 167, 255, 1);
}
.radius2 {
  /* position: absolute;
  bottom: 0.08rem; */
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 100%;
  background: rgba(11, 167, 255, 1);
}
.check{
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  position: absolute;
  top: 50%;
  margin-top: -0.125rem;
  left: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutWEEE.vue